import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-patients-empty',
  template: `
    <div class="mt-40 flex max-w-[390px] flex-1 flex-col items-center self-center text-center text-text-tertiary sm:w-[442px] lg:w-[602px]">
      <svg-icon key="px-40-search-not-found" size="xl" class="mb-4"></svg-icon>
      <span class="typo-h1 mb-2 font-semibold">
        {{ 'patientSearch_list_empty_title' | translate }}
      </span>
      <span class="typo-h4-light ">
        {{ 'patientSearch_list_empty_hint' | translate }}
      </span>
    </div>
  `,
  styles: `
    :host {
      @apply w-full h-full flex items-center justify-center;
    }
  `,
  imports: [TranslateModule, SvgIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatientsEmptyComponent {}
